import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { AuthedUser } from "../../types/types";
import { fnDictSetIndex } from "../shared";
import { createAsyncThunk } from "@reduxjs/toolkit";

import { addToQueue } from './prefsSlice';

export const updateUserAsync = createAsyncThunk(
  "auth/updateUser",
  async (payload: { keyaddress: string; keyvalue: any; }, thunkAPI) => {
    const { dispatch } = thunkAPI;
    // console.log("call updateUserAsync",payload)
    if(payload.keyaddress.startsWith('userattributes.')) {
      const newKeyAddress = payload.keyaddress.slice('userattributes.'.length);
      
      dispatch(addToQueue({
        type: 1,
        prefname: '',
        keyaddress: newKeyAddress,
        keyvalue: payload.keyvalue
      }));
    }
    dispatch(updateUser(payload));
    return payload; // Return the payload
  }
);

interface AuthState {
  user: AuthedUser | null;
  isAuthenticated: boolean;
  loginOpen: boolean;
  returnLocation: string | null; 
  error?:string;
  hasPendingPreferences: boolean;
}

const initialState: AuthState = {
  user: null,
  isAuthenticated: false,
  loginOpen: false,
  returnLocation: null, 
  hasPendingPreferences: false,
};

export const authSlice = createSlice({
  name: "auth",
  initialState,
  reducers: {
    loginSuccess: (state, action: PayloadAction<AuthedUser>) => {
      state.user = action.payload;
      state.isAuthenticated = true;
    },
    logout: (state) => {
      state.user = null;
      state.isAuthenticated = false;
    },
    setLoginOpen: (state, action: PayloadAction<boolean>) => {
      state.loginOpen = action.payload;
    },
    setHasPendingPreferences: (state, action: PayloadAction<boolean>) => {
      state.hasPendingPreferences = action.payload;
    },
    setReturnLocation: (state, action: PayloadAction<string>) => {
      state.returnLocation = action.payload;
    },
    clearReturnLocation: (state) => {
      state.returnLocation = null;
    },
    updateUser: (state, action: PayloadAction<{ keyaddress: string; keyvalue: any;  }>) => {
      const { keyaddress, keyvalue  } = action.payload;
      if (state.user) {
        // console.log('updating user',keyaddress, keyvalue)
        fnDictSetIndex(state.user, keyaddress, keyvalue);
      }
    },
    setLastRefresh: (state) => {
      fnDictSetIndex(state, 'user.refresh', new Date().getTime()+1000*60*15);
    },
    setError: (state, action: PayloadAction<string>) => {
      state.error = action.payload;
    },
  },

});

export const { loginSuccess, logout, setLoginOpen, setReturnLocation, clearReturnLocation, updateUser, setLastRefresh, setHasPendingPreferences,setError } = authSlice.actions;
export const selectLoginOpen = (state: { auth: AuthState }) => state.auth.loginOpen;
export const selectAuthenticated = (state: { auth: AuthState }) => state.auth.isAuthenticated;
export const selectUser = (state: { auth: AuthState }) => state.auth.user; // Selector to get the user object
export const selectReturnLocation = (state: { auth: AuthState }) => state.auth.returnLocation; // new selector
export const selectHasPendingPreferences = (state: { auth: AuthState }) => state.auth.hasPendingPreferences;

export default authSlice.reducer;
